import React from "react";
import Skeleton from "../../Common/Skeleton";


// Legend Item Skeleton Helper
const LegendItemSkeleton = () => (
  <div className="flex min-w-0 items-start gap-1.5 sm:gap-2.5">
    <Skeleton className="mt-1 size-1.5 !rounded-full shrink-0 sm:size-2" />
    <div className="space-y-1">
      <Skeleton className="h-2.5 w-8 rounded sm:h-3 sm:w-16" />
      <Skeleton className="h-2 w-12 rounded sm:h-2.5 sm:w-20" />
      <Skeleton className="h-2 w-9 rounded sm:h-2.5 sm:w-12" />
    </div>
  </div>
);

// Full BalanceCard Skeleton Component
export const BalanceCardSkeleton = () => {
  return (
    <Skeleton className="p-6 font-outfit rounded-2xl">
      <div className="flex flex-col gap-8 md:flex-row">
        {/* Left Column: Balance Info & Action Buttons */}
        <div className="flex flex-1 flex-col justify-between gap-6 min-w-0">
          <div>
            {/* Subtitle & Mobile Pro-View Toggle */}
            <div className="flex items-center justify-between">
              <Skeleton className="h-3 w-36 rounded" />
              <Skeleton className="h-6 w-16 !rounded-full sm:hidden" />
            </div>

            {/* Total Crypto Balance Amount */}
            <Skeleton className="my-5 h-10 w-52 rounded-lg" />

            {/* Assets Subtext */}
            <Skeleton className="mt-2 h-4 w-32 rounded max-sm:hidden" />
            <Skeleton className="mt-2 h-2.5 w-24 rounded" />

            {/* Desktop Pro-View Toggle */}
            <div className="flex space-x-3">
              <Skeleton className="mt-4 h-7 w-16 !rounded-lg max-sm:hidden" />
              <Skeleton className="mt-4 h-7 w-12 !rounded-xl max-sm:hidden" />
            </div>
          </div>

          {/* Action Buttons Group */}
          <div className="grid grid-cols-4 gap-3 sm:flex sm:flex-wrap">
            <Skeleton className="h-10 rounded-[8px] max-sm:col-span-4 sm:w-32" />
            <Skeleton className="h-10 rounded-[8px] max-sm:col-span-2 sm:w-28" />
            <Skeleton className="h-10 rounded-[8px] max-sm:col-span-2 sm:w-28" />
          </div>
        </div>

        {/* Right Column: Portfolio Breakdown Chart */}
        <div className="flex flex-1 flex-col justify-between gap-6 min-w-0">
          <div className="w-full">
            {/* Breakdown Header Title */}
            <Skeleton className="h-3 w-40 rounded" />

            <div className="mt-4 flex items-center justify-between gap-3 sm:mr-4 sm:gap-x-4">
              {/* Left Legend Column */}
              <div className="flex min-w-0 flex-1 self-start flex-col items-start gap-3 sm:gap-3.5">
                {Array.from({ length: 4 }).map((_, index) => (
                  <LegendItemSkeleton key={index} />
                ))}
              </div>

              {/* Segmented donut ring skeleton */}
              <div className="relative flex h-[130px] w-[130px] shrink-0 items-center justify-center sm:h-[160px] sm:w-[160px]">
                <svg
                  aria-hidden="true"
                  className="absolute inset-0 h-full w-full -rotate-90"
                  viewBox="0 0 100 100"
                >
                  <circle
                    cx="50"
                    cy="50"
                    r="42"
                    fill="none"
                    className="animate-pulse stroke-skeleton-start"
                    strokeWidth="9"
                    strokeDasharray="53 13"
                    strokeLinecap="round"
                  />
                </svg>
                <Skeleton className="h-4 w-20 rounded sm:h-5 sm:w-24" />
              </div>

              {/* Right Legend Column */}
              <div className="flex min-w-0 flex-1 self-start flex-col items-start gap-3 sm:gap-3.5">
                {Array.from({ length: 4 }).map((_, index) => (
                  <LegendItemSkeleton key={index} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Skeleton>
  );
};
